interface LoadScriptProps {
    src: string
    id?: string
    asynchronous: boolean
    onload?: () => void
}
export function loadScript({src, id, asynchronous = false, onload = () => {}}: LoadScriptProps) {
    if (document.querySelectorAll(`[src="${src}"]`).length > 0) {
        return
    }
    const script = document.createElement('script')

    script.src = src
    script.async = asynchronous
    script.onload = onload
    if (id) {
        script.id = id
    }

    document.body.appendChild(script)
}
